import axios from 'axios';

// Production API URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.bringit.co.in/api';

// Debug: Log the API URL being used
console.log('🌐 API Base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const userAPI = {
  // Auth
  register: (data: any) => api.post('/users/register', data),
  login: (data: any) => api.post('/users/login', data),
  getProfile: () => api.get('/users/profile'),
  updateProfile: (data: any) => api.put('/users/profile', data),
  
  // Items
  getItems: (params?: any) => api.get('/items', { params }),
  getItemSuggestions: (query: string) => api.get(`/items/suggest?q=${query}`),
  
  // Stores
  getStores: () => api.get('/stores'),
  
  // Orders
  createOrder: (data: any) => api.post('/orders', data),
  getMyOrders: () => api.get('/orders'),
  getOrderById: (id: string) => api.get(`/orders/${id}`),
  cancelOrder: (id: string) => api.delete(`/orders/${id}`),
  
  // Enhanced order flow
  trackOrder: (id: string) => api.get(`/orders/${id}/track`),
  confirmPayment: (id: string, paymentMethod: string) => 
    api.post(`/orders/${id}/confirm-payment`, { paymentMethod }),
  confirmDelivery: (id: string, otp: string, tip?: number) => 
    api.post(`/orders/${id}/confirm-delivery`, { otp, additionalTip: tip || 0 }),
  
  // Custom orders
  createCustomOrder: (data: any) => api.post('/orders/custom', data),
  confirmCustomBill: (id: string, confirmed: boolean, paymentMethod?: string) => 
    api.post(`/orders/${id}/custom-confirm`, { confirmed, paymentMethod }),
  getOrderMessages: (id: string) => api.get(`/orders/${id}/messages`),
  sendOrderMessage: (id: string, text: string) => 
    api.post(`/orders/${id}/message`, { sender: 'Customer', text }),
  
  // Banners
  getBanners: () => api.get('/banners'),
};

export default api;
